import React from "react";
import { Modal, Button } from "react-bootstrap";

import successIcon from "../../assets/images/success_icon.svg";
import errorIcon from "../../assets/images/error_icon.svg";

const CONFIG = {
  success: {
    icon: successIcon,
    title: "Success",
    buttonText: "OK",
    buttonVariant: "primary",
  },
  error: {
    icon: errorIcon,
    title: "Something went wrong",
    buttonText: "Close",
    buttonVariant: "danger",
  },
};

const StatusPopup = ({
  show,
  type = "success",
  title,
  message,
  handleClose,
  onConfirm,
}) => {
  const config = CONFIG[type];

  return (
    <Modal show={show} onHide={handleClose} centered className="delete_popup">
      <Modal.Body className="text-center">
        <img src={config.icon} alt="" style={{ width: "25%" }} />

        <h4 className="fs_20 fw_500 mb-0 mt_10">
          {title || config.title}
        </h4>

        {message && (
          <p className="fs_10 mt_10">
            {message}
          </p>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0 justify-content-center">
        <Button
          variant={config.buttonVariant}
          className={`btn_${config.buttonVariant}`}
          onClick={() => {
            if (onConfirm) onConfirm();
            handleClose();
          }}
        >
          {config.buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StatusPopup;